import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

import AdminLayout from "../components/AdminLayout";
import NAPBoxesMap from "../components/ui/NAPBoxesMap";
import { API } from "../App";

export default function NAPBoxNetworkMap() {
  const [boxes, setBoxes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNAPBoxes = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API}/nap-boxes`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setBoxes(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        toast.error(
          error.response?.data?.detail || "Failed to load NAP Box locations",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchNAPBoxes();
  }, []);

  return (
    <AdminLayout>
      <div className="p-4 sm:p-6 lg:p-8 space-y-6">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
            NAP Box Network Map
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            View the geographic locations of your registered NAP Boxes.
          </p>
        </div>

        {loading ? (
          <div className="flex min-h-64 items-center justify-center">
            Loading NAP Box locations...
          </div>
        ) : (
          <NAPBoxesMap boxes={boxes} />
        )}
      </div>
    </AdminLayout>
  );
}
